import React, { FC } from "react";
import "./ButtonGroup.scss";

export interface ButtonGroupProps {
    children: React.ReactNode;
    className?: string;
}

export const ButtonGroup: FC<ButtonGroupProps> = ({ children, className = "" }) => {
    return (
        <div className={`button-group ${className}`}>
            {children}
        </div>
    );
};